import { render, staticRenderFns } from "./Chem154_L2PostLab_Question3.vue?vue&type=template&id=dbf3af20&scoped=true&"
import script from "./Chem154_L2PostLab_Question3.vue?vue&type=script&lang=js&"
export * from "./Chem154_L2PostLab_Question3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf3af20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VImg,VSelect})
